<template>
	<div class="content">
		<div class="content_head">

			<select v-model="areaID" v-if="$store.state.user.UserType==0" @change="pageIndex=1;getData()">
				<option v-for="(i,index) in $store.state.area" :value="i.areaID">{{i.areaName}}</option>
			</select>
			<input type="text" v-model="search" @keypress.enter="pageIndex=1;getData()" class="search"
				placeholder="店铺名称|店铺地址" />
			<button type="button" class="button " @click="pageIndex=1;getData()">查找</button>
			<button type="button" class="button add" @click="clear();Edit='add'">+新增</button>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>店铺名称</th>
						<th>店铺类别</th>
						<th>店铺状态</th>
						<th>归属店铺</th>
						<th>加盟费用</th>
						<th>开始时间</th>
						<th>结束时间</th>
						<th>图书数量</th>
						<th>开设手工课</th>
						<th>店铺地址</th>
						<th>修改</th>
					</tr>
				</thead>
				<tbody>

					<tr v-for="(i,index) in shops">
						<td>
							{{index+1+ (pageIndex-1)*pageRows}}
						</td>
						<td>{{i.ShopName}}</td>
						<td>{{i.ShopType | ShopType}}</td>
						<td>{{i.ShopState | ShopState}}</td>
						<td>{{i.ParentShopName}}</td>
						<td>{{i.PayMoney+'元'}}</td>
						<td> {{$moment (i.BeginDate).format('YYYY年MM月DD日')}}</td>
						<td> {{$moment (i.EndDate).format('YYYY年MM月DD日')}}</td>
						<td class="red"> {{i.BooksCount+'本'}}</td>
						<td>{{i.IsSubject==0?'是':'否'}}</td>
						<td>{{i.ShopAddress}}</td>

						<td>
							<button :disabled="$store.state.user.UserType>1 || $store.state.user.ShopType>1"
								:class="{'disabled':$store.state.user.UserType>1 || $store.state.user.ShopType>1}" type="button" class="button"
								@click='updateArea(i)'>修改</button>
						</td>
					</tr>

				</tbody>
			</table>
		</div>
		<div class="foot_pages">
			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>

			<select v-model="pageRows" @change="changePageRows">
				<option value="5">5/页</option>
				<option value="10">10/页</option>
				<option value="15">15/页</option>

			</select>
			<button class="button" :class="{'disabled':down}" :disabled="down" @click="changePages('down')">下一页</button>
		</div>

		<div class="booksMangement" v-show="Edit!='' && Edit!='code'">
			<div v-show="Edit!=''">
				<div>
					<span class="red">*</span>店铺名称:
				</div>
				<div>
					<input type="text" v-model="ShopName" placeholder="店铺名称" required="required" />
					<span class="err">{{ShopName.length!=0?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>店铺类别:
				</div>
				<div>
					<select v-model="editShopType" :disabled="$store.state.user.UserType !=0">
						<option v-for="(i,index) in ShopType" :value="i.ID">{{i.text}}</option>
					</select>
				</div>

				<div>
					<span class="red">*</span>店铺状态:
				</div>
				<div>
					<select v-model="editShopState" :disabled="$store.state.user.UserType !=0">
						<option v-for="(i,index) in ShopState" :value="i.ID">{{i.text}}</option>
					</select>
				</div>


				<div>
					<span class="red">*</span>加盟费用:
				</div>
				<div>
					<input type="text" v-model="PayMoney" placeholder="加盟费用" required="required" />
					<span class="err">{{PayMoney>=0?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>开始时间:
				</div>
				<div>
					<input type="text" v-model="BeginDate" placeholder="开始时间,格式2021-01-01" />
					<span class="err">{{$uil.checkDate(BeginDate)?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>结束时间:
				</div>
				<div>
					<input type="text" v-model="EndDate" placeholder="结束时间,格式2021-01-01" />
					<span class="err">{{$uil.checkDate(EndDate)?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>课程开设:
				</div>
				<div>
					 <select v-model="IsSubject" :disabled="$store.state.user.UserType !=0">
						 <option value="0">是</option>
						 <option value="1">否</option>
					 </select>
				</div>

				<div>
					<span class="red">*</span>店铺地址:
				</div>
				<div>
					<input type="text" v-model="ShopAddress" placeholder="店铺的详细地址" required="required" />
					<span class="err">{{ShopAddress!=''?' ':'×'}}</span>
				</div>

				<div>
				</div>
				<div>

					<button class="button" :class="{'disabled':!checkShop}" :disabled="!checkShop"
						@click="editShop">{{ editShopID==0?'新增':'修改'}}</button>
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					<button class="button" @click="Edit='';clear()">取消</button>
				</div>
			</div>
		</div>

	</div>

</template>

<script>
	import j from './ShopMangment.js'
	export default j
</script>

<style>

</style>
